@if (strength !== null) {
  <div>
    <div [style.width.%]="(strength + 1) * 20"
         [ngClass]="getStrengthClass()"
         class="strength-bar"></div>
  </div>
}
